export default {
  portal: {
    login: {
      username: "Username",
      inputUsername: "Username",
      password: "Password",
      inputPassword: "Password",
      checkCode: "Verification",
      inputCheckCode: "Verification",
      loginText: "Sign in",
      slider:"Slider",
      sliderFalse:"Slider error",
      usernameNotEmpty: "Please enter your username.",
      passwordNotEmpty: "Please enter your password."
    }
  }
}